/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Nav_FeaturesInputs */

const en_platform_nav_features = /** @type {(inputs: Platform_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const pl_platform_nav_features = /** @type {(inputs: Platform_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Platform_Nav_FeaturesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_nav_features = /** @type {((inputs?: Platform_Nav_FeaturesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Nav_FeaturesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_nav_features(inputs)
	return en_platform_nav_features(inputs)
});